import * as csv from '@vanillaes/csv';

/**
 * Download a file text content
 */
export function openAndDownloadTextFile(textContent: string, fileType = 'text/plain'): void {
    const blob = new Blob([textContent], { type: fileType });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
}

/**
 * Download a CSV file.
 */
export function openAndDownloadCSVFile<T extends { [key: string]: any }>(
    data: T[],
    columns: Array<keyof T>
): void {
    const raw: any[][] = [];

    raw.push(columns);

    for (const item of data) {
        const row: any[] = [];
        for (const column of columns) {
            row.push(item[column]);
        }
        raw.push(row);
    }

    const textContent = csv.stringify(raw, {}, encodeCSVValue);

    openAndDownloadTextFile(textContent, 'text/csv');
}

function encodeCSVValue(input: any): string {
    if (typeof input === 'undefined') {
        return '';
    }

    return String(input);
}
